// extracted by mini-css-extract-plugin
export default {"sceleton":"Skeleton_sceleton__NcO5e","skeleton":"Skeleton_skeleton__Ea-Xp"};